import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import AdvertisingCookies from "@/pages/AdvertisingCookies";
import TermsOfUse from "@/pages/TermsOfUse";
import AboutUs from "@/pages/AboutUs";
import Portfolio from "@/pages/Portfolio";
import Insights from "@/pages/Insights";
import InsightDetail from "@/pages/InsightDetail";
import Careers from "@/pages/Careers";
import InvestmentStrategy from "@/pages/InvestmentStrategy";
import ContactUs from "@/pages/ContactUs";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/advertising-cookies" element={<AdvertisingCookies />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/insights" element={<Insights />} />
        <Route path="/insights/:slug" element={<InsightDetail />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/investment-strategy" element={<InvestmentStrategy />} />
        <Route path="/contact" element={<ContactUs />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
